import moment from 'moment/moment';

export const getDrawTimeLeft = (drawStartedAt: string): number => {
  const dateStartedAt = moment.utc(drawStartedAt);
  const dateNow = moment.utc();
  const difference = dateNow.diff(dateStartedAt, 'seconds');

  return difference < 0 ? 0 : difference;
};
